export default __webpack_public_path__ + "static/media/Meeting_rooms.6649695c.jpg";